import {
  CREATE_BULK_DEMAND_PTL,
} from './actions';

import { REQUEST, SUCCESS, FAILURE } from '../../../utils/actionGenerator';

const defaultState = {
  response: null,
  loading: false
};

export default function (state = defaultState, action) {
  switch (action.type) {
    case CREATE_BULK_DEMAND_PTL[REQUEST]:
      return { ...state, response: null, loading: true };
    case CREATE_BULK_DEMAND_PTL[SUCCESS]:
      return { ...state, response: action.response, loading: false };
    case CREATE_BULK_DEMAND_PTL[FAILURE]:
      return { ...state, response: null, loading: false };
    default:
      return state;
  }
}

export const getcreateDemandReducer = (state) => state.createBulkDemandPTL.response;
